import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1930. 請求タスクファイル削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_documents/:invoice_task_document_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const destroyInvoiceTaskDocument = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_documents/${props.id}`
  );
};

export const useDestroyInvoiceTaskDocument = () => {
  return useMutation({
    mutationFn: destroyInvoiceTaskDocument
  });
};
